// BUNDLED: pdp-bundle.js
export default function() {
	jQuery(function ($) {
		Handlebars.registerHelper('hasTab1Content', function() {
			if (this.Short_Description__c) {
				return true;
			}

			// Show tab if at least one complete feature card exists to match PDPTabbedContentCards partial check
			return !!(
				(this.Feature_Image_1__c && this.Feature_Title_1__c) ||
				(this.Feature_Image_2__c && this.Feature_Title_2__c) ||
				(this.Feature_Image_3__c && this.Feature_Title_3__c) ||
				(this.Feature_Image_4__c && this.Feature_Title_4__c)
			);
		});

		Handlebars.registerHelper('hasTab2Content', function() {
			return !!(this.Measurement_Image__c ||
				(this.dimensionRows && this.dimensionRows.length > 0) ||
				this.Care_Warranty_Description__c);
		});

		Handlebars.registerHelper('hasTab3Content', function() {
			return !!(this.Number_of_Parcels__c || this.Delivery_Options__c || this.Returns__c ||
				this.Assembly_Description__c || this.Assembly_Needed__c || this.Tools_Required__c);
		});

		Handlebars.registerHelper('hasDeliveryContent', function() {
			return !!(this.Number_of_Parcels__c || this.Delivery_Options__c || this.Returns__c);
		});

		Handlebars.registerHelper('hasAssemblyContent', function() {
			return !!(this.Assembly_Description__c || this.Assembly_Needed__c || this.Tools_Required__c);
		});
	});
}
